import React from "react";

import "./styles.css"
import "../styles.css"
import {MANUAL_PDF_NAME, PROD_LINK_PDF, STAGE_LINK_PDF} from "../../constants/default-values";
import {useTranslation} from "react-i18next";
import clsx from "clsx";

const Help = () => {
    const {t, i18n} = useTranslation()
    const {resolvedLanguage} = i18n

    const _generateManualLink = () => {
        let baseLink = ''
        if (process.env.REACT_APP_INSTANCE === "prod" || process.env.REACT_APP_INSTANCE === "local") {
            baseLink = STAGE_LINK_PDF
        } else {
            baseLink = PROD_LINK_PDF
        }

        return `${baseLink}/manual/${resolvedLanguage}/${MANUAL_PDF_NAME}`
    }

    return <div className={"help-container"}>
        <div className={clsx("help-pdf-wrapper", 'pdf-iframe-styles')}>
            <iframe
                width="100%"
                height="100%"
                title={t("SCREENS.HELP.IFRAME_TITLE")}
                src={_generateManualLink()}/>
        </div>
    </div>
}

export default Help